import React, { useEffect, useCallback, useState} from 'react';
import RolloffDropdown from './RolloffDropdown.js';
import {
    setShowFormantEffect} from 'actions/index.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import {connect} from 'react-redux';

const FormantParameters = ({formant, setShowFormantEffect, showFormantEffect}) => { 
    useEffect(() => {
        let _formantEffect = formant.oscillator.instrument.sequencerEngine.state.instruments.showFormantEffect;
        if (formant !== _formantEffect && _formantEffect) {
            setShowFormantEffect(formant);
        }
    }, [formant]);

    useEffect(() => {
        return () => setShowFormantEffect(undefined);
    }, []);

    return (
        <div className="formant-parameters">
          <div className="inner">
          <EffectParameterSlider
            sequencerEngine={formant.oscillator.sequencerEngine}
            name={'Frequency'}
            parameter={formant.formantFrequencyParameter}
            onParameterChanged={() => []}
            lfoEnabled={true}
            isParameter={true}
            root={2}
            min={0}
            max={20000}
            step={1}
          />
          <EffectParameterSlider
            sequencerEngine={formant.oscillator.sequencerEngine}
            name={'Q'}
            parameter={formant.formantQParameter}
            root={2}
            onParameterChanged={() => []}
            lfoEnabled={true}
            isParameter={true}
            min={0.1}
            max={50}
            step={0.01}
          />
          </div>
          <div className="inner">
          <EffectParameterSlider
            sequencerEngine={formant.oscillator.sequencerEngine}
            name={'Gain'}
            parameter={formant.formantGainParameter}
            root={2}
            onParameterChanged={() => []}
            lfoEnabled={true}
            isParameter={true}
            min={0}
            max={3.9}
            step={0.01}
          />
            <RolloffDropdown formant={formant}/>
          </div>
          <div
            onClick={() => setShowFormantEffect(showFormantEffect ? undefined : formant)}
            className={showFormantEffect ? "fx-button show" : "fx-button"}>
            <span>FX</span> {formant.effect ? <span className="fx-name">{formant.effect.name}</span> : ''}
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      showFormantEffect: state.instruments.showFormantEffect
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setShowFormantEffect: (x) => dispatch(setShowFormantEffect(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantParameters);
